import { useEffect, useRef, useState } from "react";
function useIntersectionObserver(options = {}) {
    const { threshold = 1, root = null, rootMargin = '0%' } = options;
    const ref = useRef(null);
    const [entry, setEntry] = useState(null);
    useEffect(()=>{
        const node = null == ref ? void 0 : ref.current;
        if (!node || 'function' != typeof IntersectionObserver) return;
        const observer = new IntersectionObserver(([entryObserver])=>{
            setEntry(entryObserver);
        }, {
            threshold,
            root,
            rootMargin
        });
        observer.observe(node);
        return ()=>{
            setEntry(null);
            observer.disconnect();
        };
    }, [
        threshold,
        root,
        rootMargin
    ]);
    return [
        ref,
        entry
    ];
}
export { useIntersectionObserver };
